import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import RouteCollection from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import AgentContent from './AgentContent';
import NoRoute from '../NoRoute';


class AgentDetail extends React.Component {
  constructor(props) {
    super(props);

    const route = RouteCollection.getRouteByPath(get(props.router, 'location.pathname'));
    const agentId = get(route, 'params.agentId');

    const agent = props.agents.find(a => a._id === agentId);

    if (agent) {
      agent.listings = props.homes.filter(home => home.agent_email === agent.email);
    }

    this.state = {
      agent,
    };
  }

  render() {
    const { agent } = this.state;
    if (agent) {
      const { builder, page } = this.props;
      const builderName = get(builder, 'name');
      const agentName = get(agent, 'name');
      const pageImage = get(page, 'page_image.contentUrl');
      const ogImage = pageImage ?
        buildThumbnailUrl(pageImage, { width: 1200, height: 1200 }) :
        `https://${builder.authDomain}/images/default-header-bg.jpg`;
      const metaDescription = `Meet and view listings from ${agentName}, an agent for ${builderName}`;
      return (
        <div>
          <PageWrapper>
            <PageHelmet
              custom
              title={`Meet ${agentName}`}
            >
              <meta name="description" content={metaDescription} />
              <meta property="og:image" content={ogImage} />
              <meta property="og:title" content={`Meet ${agentName} | ${builderName}`} />
              <meta property="og:description" content={metaDescription} />
            </PageHelmet>
            <main>
              <InsideHeader
                h1="Meet Our Agents"
                background={pageImage}
              />
              <AgentContent agent={agent} />
            </main>
          </PageWrapper>
        </div>
      );
    }
    return (
      <NoRoute />
    );
  }
}

AgentDetail.propTypes = {
  agents: PropTypes.arrayOf(PropTypes.object).isRequired,
  builder: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
  agents: true,
  homes: 'all',
  page: 'agents',
  router: true,
})(AgentDetail);



// WEBPACK FOOTER //
// ./src/pages/AgentDetail/index.js